import { render, staticRenderFns } from "./DataTransmission.vue?vue&type=template&id=0181cd77&scoped=true&lang=pug&"
import script from "./DataTransmission.vue?vue&type=script&lang=ts&"
export * from "./DataTransmission.vue?vue&type=script&lang=ts&"
import style0 from "./DataTransmission.vue?vue&type=style&index=0&id=0181cd77&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0181cd77",
  null
  
)

export default component.exports